import type { NotificationSeverity } from './Notification'

export type BannerAction = Readonly<{ label: string, onClick: () => void }>

/**
 * Figma's Banner has no `success` variant (only error/warning/info) - unlike Toast/InlineAlert.
 */
export type BannerSeverity = Exclude<NotificationSeverity, NotificationSeverity.SUCCESS>

export type BannerItem = Readonly<{
    severity: BannerSeverity
    title: string
    description?: string
    action?: BannerAction
    /** Identifies the condition this banner represents, for session-scoped dismiss tracking. */
    dismissKey: string
}>

export type BannerAppState = Readonly<{ activeBanner: BannerItem | null }>

export const selectActiveBanner = (s: BannerAppState): BannerAppState['activeBanner'] => s.activeBanner
